import { Action, combineReducers } from "@reduxjs/toolkit";

import {
	executors,
	accountsExecutorsAction,
	StateExecutors,
} from "./Executors";
import { carParks, accountsCarParksAction, StateCarParks } from "./CarParks";
import { Accounts } from "./interface";

export { Accounts };

export type State = {
	executors: StateExecutors;
	carParks: StateCarParks;
};

export type Actions = {
	executors: typeof accountsExecutorsAction;
	carParks: typeof accountsCarParksAction;
};

export const accountsReducer = combineReducers<State, Action<Actions>>({
	executors,
	carParks,
});

export const accountsAction: Actions = {
	executors: accountsExecutorsAction,
	carParks: accountsCarParksAction,
};

export default accountsReducer;
